document.addEventListener('DOMContentLoaded', function () {
  const form = document.querySelector('form[action="/cart/add"]');
  
  const popup = document.createElement('div');
  const addToCartButton = document.getElementById('ProductSubmitButton-template--18878354882737__main');
  const qtyInput = document.getElementById('Quantity-template--18878354882737__main');

const groupData = document.getElementById("selling-plan-groups-data");
let dropstreetPlans = [];

window.formatPhoneInput = function(input) {
  // Remove all non-digit characters
  let digits = input.value.replace(/\D/g, '');

  // Limit to 10 digits
  digits = digits.slice(0, 10);

  // Format as XXX-XXX-XXXX
  let formatted = digits;
  if (digits.length > 6) {
    formatted = `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
  } else if (digits.length > 3) {
    formatted = `${digits.slice(0, 3)}-${digits.slice(3)}`;
  }

  input.value = formatted;
};
 window.validatePhone= function(phone) {
  // Remove non-digit characters and check for exactly 10 digits
  const digitsOnly = phone.replace(/\D/g, '');
  return /^\d{10}$/.test(digitsOnly);
}
if (groupData) {
  const sellingPlanGroups = JSON.parse(groupData.textContent);

  // Filter by specific group name or ID
  const TARGET_GROUP_NAME = "Dropstreet Reminders"; // or use group.id
  const targetGroup = sellingPlanGroups.find(group => group.name === TARGET_GROUP_NAME);

  if (targetGroup) {
    dropstreetPlans = targetGroup.selling_plans;
    console.log("Selling Plans from group:", dropstreetPlans);
  } else {
    console.log("No matching selling plan group found.");
    return;
  }
}else{
  return;
  
}


const popupTemplates = {
  1: `
    <div class="popup">
    <div class="icon-popup">
      <img src="${window.assetUrls.icon}" alt="icon">
    </div>
    <h2>Might want more later?<br />You can reorder through text message!</h2>
    <p class="subtitle">First – we text you. Then – You can reply to the text to reorder.</p>

    <div class="popup-form">
      <div class="popup-field">
        <label for="checkin">When do you want a check-in:</label>
        <small>No commitment required</small>
        <select id="subscription-plan-select">
          <option value="">e.g. 2 weeks, 1 month</option>
          ${dropstreetPlans.map(plan => `<option value="${plan.id}">${plan.name}</option>`).join('')}
        </select>
      </div>

      <div class="popup-field">
        <label for="phone">Enter your mobile number:</label>
        <small>No spam texts here</small>
        <input type="text" id="subscription-phone" placeholder="e.g. +9178675309"  />
      </div>

      <div class="info">See how it works <i>→ </i> <span class="tooltip">?
        <span class="tooltip-text">
            <span style="font-size:11px">Re-order through text message! <br><br>Get a text reminder for easy re-orders.<br> Just REPLY TO BUY! We simply save your payment and shipping info (securely) for easy future ordering. FREE TO SIGN UP!</span>
            <br><br>
            You are subscribing to receive promotion text messages (SMS & MMS). Message and data rates may apply. To successfully make future purchases through SMS, you are authorizing the use of the existing payment and shipping information you save on your account.
        </span>
    </span></div>

      <button  class="btn-popup" id="confirm-subscription">Yes, send a check-in</button>
    </div>

    <button class="dismiss" id="cancel-subscription">Maybe next time</button>
    <p id="phoneError" style="color:red; display:none; margin-top:10px;">Please enter a valid phone number.</p>
  </div>
  `,
  2: `
     <div class="popup">
    <div class="icon-popup">
      <img src="${window.assetUrls.icon}" alt="icon" />
    </div>
    <h2>Re-order with 1 text?</h2>
    <p class="subtitle">Tell us when you want us to text you & if you want to re-order, just reply to the text to buy again. SUPER EASY!</p>

    <div class="popup-form">

      <div class="fields-row">
      <div class="popup-field field-left">
        
       
        <input type="text" id="subscription-phone" placeholder="Enter your mobile number:"   />
         <small>We’ll only text you a check-in text—no spam </small>
      </div>

      <div class="popup-field field-right">
        
       
        <select id="subscription-plan-select">
          <option value="">Select check-in date</option>
          ${dropstreetPlans.map(plan => `<option value="${plan.id}">${plan.name}</option>`).join('')}
        </select>
         <small>No commitment required</small>
      </div>

      </div>

      <button  class="btn-popup"  id="confirm-subscription">All set</button>
    </div>

    <button class="dismiss" id="cancel-subscription">Maybe next time</button>
    <div class="info">See how it works <i>→ </i> <span class="tooltip">?
        <span class="tooltip-text">
            <span style="font-size:11px">Re-order through text message! <br><br>Get a text reminder for easy re-orders.<br> Just REPLY TO BUY! We simply save your payment and shipping info (securely) for easy future ordering. FREE TO SIGN UP!</span>
            <br><br>
            You are subscribing to receive promotion text messages (SMS & MMS). Message and data rates may apply. To successfully make future purchases through SMS, you are authorizing the use of the existing payment and shipping information you save on your account.
        </span>
    </span></div>
  </div>
  `,
  3: `
    <div class="popup">
    <div class="icon-popup">
      <img src="${window.assetUrls.icon2}" alt="icon">
    </div>
    <h2>Might want to re-order through text?</h2>
    <p class="subtitle">We’ll text you, in case you want to re-order,<br>just reply to the text to buy again</p>

    <div class="popup-form">
      <div class="popup-field">
        <label for="checkin">Pick your check-in date:</label>
        <small>No commitment required</small>
        <select id="subscription-plan-select">
          <option value="">e.g. 2 weeks, 1 month</option>
          ${dropstreetPlans.map(plan => `<option value="${plan.id}">${plan.name}</option>`).join('')}
        </select>
      </div>

      <div class="popup-field">
        <label for="phone">Enter your mobile number:</label>
        <small>No spam texts here</small>
        <input type="text" id="subscription-phone" placeholder="e.g. +9178675309"  />
      </div>

      <div class="info">See how it works <i>→ </i> <span class="tooltip">?
        <span class="tooltip-text">
            <span style="font-size:11px">Re-order through text message! <br><br>Get a text reminder for easy re-orders.<br> Just REPLY TO BUY! We simply save your payment and shipping info (securely) for easy future ordering. FREE TO SIGN UP!</span>
            <br><br>
            You are subscribing to receive promotion text messages (SMS & MMS). Message and data rates may apply. To successfully make future purchases through SMS, you are authorizing the use of the existing payment and shipping information you save on your account.
        </span>
    </span></div>

      <button  class="btn-popup" id="confirm-subscription">Yes, send a check-in</button>
    </div>

    <button class="dismiss" id="cancel-subscription">Maybe next time</button>
    <p id="phoneError" style="color:red; display:none; margin-top:10px;">Please enter a valid phone number.</p>
  </div>
  `,
  4: `
    <div class="popup">
    <div class="icon-popup">
      <img src="${window.assetUrls.icon2}" alt="icon">
    </div>
    <h2>Interested in re-ordering<br>with one text in the future?</h2>
    <p class="subtitle">We’ll send you a check-in text & if you want to re-order:<br>
just reply to the text to buy again! Super Easy!</p>

    <div class="popup-form">
      

      <div class="popup-field">
        
        
        <input type="text" id="subscription-phone" placeholder="Enter your mobile number:"  />
        <small>We’ll only text you a check-in text—no spam </small>
      </div>

      <div class="popup-field">
        <select id="subscription-plan-select">
          <option value="">Select check-in date</option>
          ${dropstreetPlans.map(plan => `<option value="${plan.id}">${plan.name}</option>`).join('')}
        </select>
        <small>No commitment required</small>
      </div>

     

      <button  class="btn-popup" id="confirm-subscription">All set</button>
<button class="dismiss" id="cancel-subscription">Maybe next time</button>
       <div class="info">See how it works <i>→ </i> <span class="tooltip">?
        <span class="tooltip-text">
            <span style="font-size:11px">Re-order through text message! <br><br>Get a text reminder for easy re-orders.<br> Just REPLY TO BUY! We simply save your payment and shipping info (securely) for easy future ordering. FREE TO SIGN UP!</span>
            <br><br>
            You are subscribing to receive promotion text messages (SMS & MMS). Message and data rates may apply. To successfully make future purchases through SMS, you are authorizing the use of the existing payment and shipping information you save on your account.
        </span>
    </span></div>
    </div>

    
    <p id="phoneError" style="color:red; display:none; margin-top:10px;">Please enter a valid phone number.</p>
  </div>
  `

};

  // Create popup content
  popup.id = 'custom-subscription-popup';
  popup.style = 'position:fixed; z-index:9999; top:0; left:0; width:100vw; height:100vh; background:rgba(0,0,0,0.6); visibility:hidden; ';

  

  const popupVariant = Math.floor(Math.random() * 4) + 1; // 1 to 4
//const popupVariant = 4;
  console.log("POPUP VARIANT"+ popupVariant);

  popup.innerHTML = popupTemplates[popupVariant];
  loadPopupCSS(popupVariant);

  setTimeout(() => {
  const phoneInput = popup.querySelector('#subscription-phone');
  if (phoneInput) {
    phoneInput.addEventListener('input', function () {
      window.formatPhoneInput(this);
    });
  }
}, 0);
  
  
  //popup.style.display = 'none';
  document.body.appendChild(popup);

  // Intercept form submit
  let intercept = true;
  

  // Intercept actual click on the button, not the form submit
  addToCartButton.addEventListener('click', function (e) {
    const oneTimeRadio = document.querySelector('input[type="radio"][data-type="one_time"]');
  const hasAnyRadios = document.querySelectorAll('input[type="radio"][data-type]').length > 0;
    console.log ("hasAnyRadios "+ hasAnyRadios);
    const shouldShowPopup =
    intercept &&
    (
      (oneTimeRadio && oneTimeRadio.checked) || // Case 1: one-time radio is checked
      (!hasAnyRadios)                          // Case 2: no subscription radios at all
    );

  if (shouldShowPopup) {
    e.preventDefault();
    popup.classList.add('show');
  }
  });

  
 
function handleSubscriptionSubmission(addSubscriptionData) {
  // Optional subscription fields
  const selectedPlan = document.getElementById('subscription-plan-select')?.value;
  const phoneSub = document.getElementById('subscription-phone')?.value;
  
 // Handle Yes
  if (addSubscriptionData) {
    if (!selectedPlan) {
      alert('Please select a subscription plan.');
      return;
    }

    if (!phoneSub) {
      alert('Please enter your phone number.');
      return;
    }else if (!validatePhone(phoneSub)){
      alert('Please enter valild phone number.');
      return;
    }

    // Add hidden fields only when subscription is being added
    const sellingPlanInput = document.createElement('input');
    sellingPlanInput.type = 'hidden';
    sellingPlanInput.name = 'selling_plan';
    sellingPlanInput.value = selectedPlan;
    form.appendChild(sellingPlanInput);


   
    
  
    const phoneInput = document.createElement('input');
    phoneInput.type = 'hidden';
    phoneInput.name = 'properties[Phone Number]';
    phoneInput.value = formatPhoneNumber(phoneSub);
    form.appendChild(phoneInput);

    logPopupEvent(popupVariant, true,true);
  }else{

    logPopupEvent(popupVariant, false,true);
  }

   const quantityInput = document.createElement('input');
    quantityInput.type = 'hidden';
    quantityInput.name = 'quantity';
    quantityInput.value = qtyInput.value;
    form.appendChild(quantityInput);

  // Hide popup and proceed
 popup.classList.remove('show');
      intercept = false;
      
      

  const formData = new FormData(form);

  fetch('/cart/add.js', {
    method: 'POST',
    body: formData,
    headers: { 'Accept': 'application/json' }
  })
    .then(res => res.json())
    .then(() => {
      return new Promise(resolve => setTimeout(resolve, 200));
    })
    .then(() => {
      return fetch('/?sections=cart-drawer').then(res => res.json());
    })
    .then(sectionData => {
      const rawHTML = sectionData['cart-drawer'];
      if (!rawHTML) {
        console.warn('[CartDrawer] No cart-drawer section returned.');
        return;
      }

      // Parse new drawer
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = rawHTML;
      const newCartDrawer = tempDiv.querySelector('cart-drawer');
      if (!newCartDrawer) {
        console.warn('[CartDrawer] No <cart-drawer> in returned HTML.');
        return;
      }

      const currentCartDrawer = document.querySelector('cart-drawer');
      if (!currentCartDrawer) {
        console.warn('[CartDrawer] No <cart-drawer> in DOM.');
        return;
      }

      // Replace drawer content
      currentCartDrawer.innerHTML = newCartDrawer.innerHTML;

      // Remove 'is-empty' if necessary
      if (currentCartDrawer.classList.contains('is-empty')) {
        currentCartDrawer.classList.remove('is-empty');
      }

      // Trigger drawer open
      const cartTrigger = document.querySelector('#cart-icon-bubble');
      if (cartTrigger) cartTrigger.click();


      

      console.log('[CartDrawer] Drawer updated and opened.');
    })
    .catch(err => {
      console.error("[CartDrawer] Error during cart update:", err);
    });
  intercept = true;
}

// Event bindings
document.getElementById('confirm-subscription').addEventListener('click', function () {
  handleSubscriptionSubmission(true); // Add subscription info
});

document.getElementById('cancel-subscription').addEventListener('click', function () {
  handleSubscriptionSubmission(false); // Skip subscription info
});


  
function formatPhoneNumber(phone) {
    phone = phone.trim(); // Remove leading/trailing spaces
   /* if (!phone.startsWith('+1')) {
        phone = '+1' + phone;
    }
    return phone;
*/
   // Remove all non-digit characters
  phone = phone.replace(/\D/g, '');

  // Limit to first 10 digits
  phone = phone.substring(0, 10);

  // Return formatted with +1 prefix
  return '+1' + phone;
  
}
function logPopupEvent(popupNumber, signed = false, submit_form=false) {
    fetch('https://dropstreet.co/api/partner/log-popup', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        },
        body: JSON.stringify({
            popup_number: popupNumber,
            signed: signed,
            source: "aldos"
        })
    })
    .then(response => {
        if (!response.ok) {
            throw new Error("Failed to log popup event");
        }
        return response.json();
    })
    .then(data => {
        console.log("Popup logged:", data);
        if(submit_form==true){
          // form.submit();
        }
    })
    .catch(error => {
        console.error("Error logging popup:", error);
        if(submit_form==true){
          //form.submit();
        }
    });
}


function loadPopupCSS(variant) {
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = window.popupCssVariants[variant];
  document.head.appendChild(link);
}
 
let  checkoutBtnFound = false;

const observer = new MutationObserver(() => {
    document.querySelectorAll(".wizz-product-subcription-name-custom").forEach(header => {
      if (header.textContent.trim() === "Dropstreet Reminders") {
        const groupWrapper = header.closest(".w4-flex.w4-flex-col");
        if (groupWrapper) {
          groupWrapper.style.display = "none"; // only hide THIS group
        }
      }
    });

    // this is for allowing coupons to work
      const checkoutButton = document.querySelector('.wizz-checkout-link');

        if (checkoutButton && !checkoutBtnFound) {
        checkoutBtnFound = true;
        checkoutButton.addEventListener('click', async function (e) {
    
          console.log("button clicked");
          e.preventDefault();
    
          try {
            const cartResponse = await fetch('/cart.js');
            const cart = await cartResponse.json();
    
            const WEEK_PLAN_GROUP_ID = 338257674417; // ← your real Week Plan group ID here
    
            for (const item of cart.items) {
              const productId = item.product_id;
              const sellingPlanAllocation = item.selling_plan_allocation;
    
            
    
              const isOneTimePurchase = typeof sellingPlanAllocation === 'undefined';
              console.log ("isOneTimePurchase "+isOneTimePurchase);
              const isSmsReminderSubscription = sellingPlanAllocation?.selling_plan?.name?.includes("SMS Reminder");
    
              if (isOneTimePurchase || isSmsReminderSubscription) {
                console.log("Adding product to Reminders collection:", productId);
                await fetch(`https://shop-app.dropstreet.co/public/product-to-collection.php?shop=aldos-coffee-company-2.myshopify.com&product_id=${encodeURIComponent(productId)}`);
              } else {
                console.log("Skipping product:", productId);
              }
            }
    
            // Redirect to checkout
            window.location.href = '/checkout';
    
          } catch (error) {
            console.error('Error before checkout:', error);
            alert('Something went wrong while preparing your checkout.');
          }
        });
      }else{
         //console.log("no checkout button found");
      }
  


  });

  observer.observe(document.body, { childList: true, subtree: true });



 const DISABLED_FLAG = "disabledUpsellProcessed";

  function shouldDisable(el) {
    // Use innerText so we check the visible label
    const text = (el.innerText || el.textContent || "").trim();
    return /sms\s+reminder/i.test(text);
  }

  function disableDropdown(el) {
    if (!el || el.dataset[DISABLED_FLAG] === "1") return;

    // Make it look/act disabled
    el.style.pointerEvents = "none";
    el.style.opacity = "0.9";
    el.style.cursor = "not-allowed";
    el.setAttribute("aria-disabled", "true");
    el.setAttribute("tabindex", "-1");

    // Block any app handlers (capture phase)
    ["click","pointerdown","mousedown","touchstart","keydown"].forEach(evt => {
      el.addEventListener(evt, e => {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
      }, true);
    });

    // Hide arrow SVG (and its wrapper)
    const arrowSvg = el.querySelector("svg");
    if (arrowSvg) {
      const wrap = arrowSvg.parentElement || arrowSvg;
      wrap.style.display = "none";
    }

    el.dataset[DISABLED_FLAG] = "1";
  }

  function evaluateAndDisable(el) {
    if (!el) return;
    // If it contains "SMS Reminder", disable it
    if (shouldDisable(el)) {
      disableDropdown(el);
    }
  }

  function scanAll() {
    // Attribute selector catches ALL nodes even if IDs are duplicated
    document.querySelectorAll("[id='w4-select-upsell']").forEach(el => {
      evaluateAndDisable(el);

      // Watch each dropdown for label changes (e.g., selection changes)
      if (!el.dataset.observeText) {
        const textObserver = new MutationObserver(() => evaluateAndDisable(el));
        textObserver.observe(el, { childList: true, subtree: true, characterData: true });
        el.dataset.observeText = "1";
      }
    });
  }

  // Initial pass
  scanAll();

  // Observe future injections/re-renders
  const observer2 = new MutationObserver((mutations) => {
    let needsScan = false;
    for (const m of mutations) {
      // Quick checks to avoid heavy scanning every time
      for (const node of m.addedNodes) {
        if (node.nodeType !== 1) continue;
        if (node.id === "w4-select-upsell" || node.querySelector?.("[id='w4-select-upsell']")) {
          needsScan = true;
          break;
        }
      }
      if (needsScan) break;
    }
    if (needsScan) scanAll();
  });
  observer2.observe(document.body, { childList: true, subtree: true });



});
/*
document.addEventListener('DOMContentLoaded', function () {
  const cartDrawer = document.querySelector('cart-drawer');

  if (!cartDrawer) {
    console.warn('Cart drawer not found');
    return;
  }

  const checkCartState = () => {
    fetch('/cart.js')
      .then((res) => res.json())
      .then((cart) => {
        console.log('[Cart Check] Cart item count:', cart.items.length);

        if (cart.items.length === 0) {
          console.log('[Cart Check] Cart is empty — adding is-empty class');
          console.log(cartDrawer);
          cartDrawer.classList.add('is-empty');
          console.log(cartDrawer);
        } else {
          console.log('[Cart Check] Cart has items — removing is-empty class');
          console.log(cartDrawer);
          cartDrawer.classList.remove('is-empty');
          console.log(cartDrawer);
        }
      })
      .catch((err) => {
        console.error('Error fetching cart data:', err);
      });
  };

  // Monitor DOM changes to the cart drawer content
  const cartItemsWrapper = cartDrawer.querySelector('[id^="CartDrawer-CartItems"]');

  if (!cartItemsWrapper) {
    console.warn('Cart drawer items container not found');
    return;
  }

  const observer = new MutationObserver(() => {
    console.log('[MutationObserver] Mutation detected. Re-checking cart state...');
    setTimeout(checkCartState, 100); // Delay to wait for theme to update classes
  });

  observer.observe(cartDrawer, {
    childList: true,
    subtree: true,
  });

  // Initial check
  checkCartState();
});

*/
/*
document.addEventListener('DOMContentLoaded', function () {
 
  const form = document.getElementById('product-form-template--17583153086658__main');
  const addToCartButton = document.getElementById('ProductSubmitButton-template--17583153086658__main');

  const popup = document.getElementById('phonePopup');
  const phoneInput = document.getElementById('phoneInput');
  const phoneError = document.getElementById('phoneError');
  const popupYes = document.getElementById('popupYes');
  const popupNo = document.getElementById('popupNo');

  let submitMethod = null;

  // Intercept actual click on the button, not the form submit
  addToCartButton.addEventListener('click', function (e) {
    e.preventDefault(); // this is crucial
    if (popup.style.display !== 'block') {
      popup.style.display = 'block';
    }
  });

  // If user clicks NO – submit without custom field
  popupNo.addEventListener('click', function () {
    popup.style.display = 'none';
    form.submit(); // default Shopify submission
  });

  // If user clicks YES – validate phone, then add it as custom property and submit
  popupYes.addEventListener('click', function () {
    const phone = phoneInput.value.trim();
    if (!/^\+?\d{7,15}$/.test(phone)) {
      phoneError.style.display = 'block';
      return;
    }

    phoneError.style.display = 'none';

    // Inject the phone number as a custom property
    const propertyInput = document.createElement('input');
    propertyInput.type = 'hidden';
    propertyInput.name = 'properties[Phone Number]';
    propertyInput.value = phone;
    form.appendChild(propertyInput);

    popup.style.display = 'none';
    form.submit(); // proceed with form submission
  });
});
*/

/*
document.addEventListener("DOMContentLoaded", function () {
  const addToCartBtn = document.querySelector('button.product-form__submit');

  // Replace this with your own check logic for subscription group
  const isSubscriptionProduct = () => {
    // Example condition: product has a specific selling plan group name or ID
    // You could check for presence of a hidden input or a class name
    return document.querySelector('[data-selling-plan-group-id="123456"]') !== null;
  };

  const showPopup = () => {
    document.getElementById('phone-popup').style.display = 'block';
  };

  const hidePopup = () => {
    document.getElementById('phone-popup').style.display = 'none';
  };

  const validatePhone = (phone) => {
    return /^\+?[0-9\s\-]{7,15}$/.test(phone);
  };

  addToCartBtn.addEventListener('click', function (e) {
    if (!isSubscriptionProduct()) return;

    e.preventDefault(); // Stop default add to cart behavior

    showPopup(); // Show custom phone popup
  });

  document.getElementById('popup-ok').addEventListener('click', function () {
    const phoneInput = document.getElementById('popup-phone');
    const errorMsg = document.getElementById('popup-error');
    const phoneValue = phoneInput.value.trim();

    if (!validatePhone(phoneValue)) {
      errorMsg.style.display = 'block';
      return;
    }

    errorMsg.style.display = 'none';

    // OPTIONAL: Store phone number in hidden input for form submission
    const hiddenPhone = document.createElement('input');
    hiddenPhone.type = 'hidden';
    hiddenPhone.name = 'properties[Phone Number]';
    hiddenPhone.value = phoneValue;
    document.querySelector('form').appendChild(hiddenPhone);

    hidePopup();

    // Submit the form programmatically
    addToCartBtn.closest('form').submit();
  });
});
*/